import React from 'react';
import { formatNumber, getCurrencySymbol } from '../../../common/Formatter';
import { useTranslation } from 'react-i18next';

type SinglePaymentDisplayProps = {
  style: string;
  text: string;
  priceSingle: number;
  culture: string;
};

const SinglePaymentDisplay = ({
  style,
  text,
  priceSingle,
  culture
}: SinglePaymentDisplayProps): JSX.Element => {
  const { t } = useTranslation();
  const singlePaymentText = t('renewals-quote.single-payment-text');
  return (
    <p>
      <span>{text}</span>
      <span>{singlePaymentText}</span>
      <span className={style}>
        {getCurrencySymbol()}
        {formatNumber(priceSingle, 2, culture)}
      </span>
    </p>
  );
};

export default SinglePaymentDisplay;
